<script>

import { QuillEditor } from '@vueup/vue-quill'
import '@vueup/vue-quill/dist/vue-quill.snow.css';
export default {
  name: 'TwWysiwyg',
  components: { QuillEditor },
  props: {
    modelValue: {
      type: [String,Number],
      default: null
    },
    label: {
      type: String,
      default: null
    },
    smallLabel: {
      type: String,
      default: null
    },
    placeholder: {
      type: String,
      default: null
    },
    id: {
      type: String,
      default: () => Math.random().toString(36).substring(7)
    },
    required: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    options: {
      type: Object,
      default: () => ({
        modules: {
          toolbar: [
            ['bold', 'italic', 'underline', 'strike'],
            ['blockquote', 'code-block'],
            [{ 'list': 'ordered'}, { 'list': 'bullet' }],
            ['link']
          ]
        },
        theme: 'snow',
        placeholder: ''
      })
    }
  },
  emits: ['update:modelValue'],

}
</script>

<template>
  <div class="w-full">
    <label v-if="label || $slots.label" :for="id" class="form-label"> <slot name="label">{{ label }}</slot> </label>
    <div v-if="smallLabel || $slots.smallLabel" class="form-label-sm">
      <slot name="smallLabel">
        {{ smallLabel }}
      </slot>
    </div>
    <QuillEditor :id="id" :options="options" class="bg-white" content-type="html" :name="id" :readonly="disabled" :autocomplete="id" :content="modelValue" :required="required" :placeholder="placeholder" @update:content="$emit('update:modelValue', $event)" />
    <slot name="under" class="text-sm text-gray-500 mt-1  font-forms" />
  </div>
</template>

<style scoped>

</style>
